import { downloadFile } from '@helpers/api/blobResponse';
import getRequest from '@helpers/api/get';

/**
 * Creates a GET request for a download and then downloads the result
 * @param {string} url File url
 * @param {string} [filename] File name for the resulting download
 * @param {Object} [options={}] Additional getRequest options
 * @param {Object} [axiosOptions={}] Additional axios options
 * @returns {Promise<unknown>} get request that will download the file on success
 */
export const downloadRequest = (url, filename, options = {}, axiosOptions = {}) =>
  getRequest(
    url,
    {},
    {
      additionalHeaders: { 'Content-Type': 'multipart/form-data' },
      onSuccess: response => downloadFile(response, filename),
      ...options,
      axiosOptions: {
        responseType: 'blob',
        ...axiosOptions,
      },
    }
  );
